import React from 'react';

const renderMergedProps = (component, ...rest) => {
  const finalProps = Object.assign({}, ...rest);
  return (
    React.createElement(component, finalProps)
  );
};

export default renderMergedProps;



// WEBPACK FOOTER //
// ./src/hoc/PropsRoute/RenderMergedProps/RenderMergedProps.js